import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const MarkPackagesPaidPage = lazy(
    () => import('../components/MarkPackagesPaidPage')
)

export const MarkPackagesPaidRoute: RouteObject = {
    path: 'mark-packages-paid',
    element: <MarkPackagesPaidPage />,
}

export default MarkPackagesPaidRoute
